/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { USAGE_TYPE } from '../../../../../../util/constants';
import { GetActualQty } from '../../../../../../util/utilityFunctions';

export const buildPayload = (
  usageDetails: any,
  catalogPartsToAdd: any[],
  inventoryPartsToAdd: any[],
  modlenData: any[],
  isERPOrder: boolean
) => {
  const payload: Array<any> = [];
  let serialNbr = usageDetails?.lineItems?.length || 0;

  catalogPartsToAdd.forEach((product: any): void => {
    let actualQty;

    if (modlenData) {
      const priceItem = modlenData.find(
        (price: any) => price.productNumber === product.productNumber
      );
      actualQty = GetActualQty(
        usageDetails?.diplayOrderType,
        priceItem?.sellingUOM || 'PCE',
        product?.salesUnitOfMeasure,
        product?.packContent,
        product?.counterValue
      );
    }

    if (product.changed && product.counterValue) {
      serialNbr += 1;
      payload.push({
        sfid: product.sfid,
        externalId: product.externalId,
        productId: product.productId,
        quantity: product.counterValue.toString(),
        lotNumber: product.lotNumber,
        isLotNumber: product.isLotNumber,
        productNumber: product.productNumber,
        serialNumber: serialNbr.toString(),
        productFamily: product.productFamily,
        subInventoryCode: product?.subInventoryCode || '',
        actualQuantity: actualQty?.toString(),
        actualPackContent: product.packContent ? product.packContent : '1',
        ...(isERPOrder && {
          caseUsageId: product.caseUsageId,
          caseUsageExternalId: product.caseUsageExternalId,
          priceBookEntryId: product.priceBookEntryId,
          salesUnitOfMeasure: product.salesUnitOfMeasure,
          deliveredDate: product.deliveredDate,
        }),
      });
    }
  });

  if (usageDetails?.diplayOrderType === USAGE_TYPE.BILL_ONLY) {
    inventoryPartsToAdd.forEach((partLocal: any): void => {
      usageDetails.lineItems.forEach((lineItem: any) => {
        if (
          lineItem.productId === partLocal.productId &&
          lineItem.lotNumber === partLocal.lotNumber
        ) {
          partLocal.externalId = lineItem.externalId;
        }
      });
    });
  }
  inventoryPartsToAdd.forEach((lotInfo: any) => {
    const { sourceLocation } = lotInfo;

    if (lotInfo.changed && lotInfo.counterValue) {
      serialNbr += 1;
      payload.push({
        sfid: lotInfo.sfid,
        externalId: lotInfo.externalId,
        lotNumber: lotInfo.lotNumber,
        productId: lotInfo.productId,
        quantity: lotInfo.counterValue.toString(),
        isLotNumber: lotInfo.isLotNumber,
        productNumber: lotInfo.productNumber,
        serialNumber: serialNbr.toString(),
        sourceLocation,
        actualPackContent: lotInfo.packContent ? lotInfo.packContent : '1',
        subInventoryCode: lotInfo?.subInventoryCode || '',
        ...(isERPOrder && {
          caseUsageId: lotInfo.caseUsageId,
          caseUsageExternalId: lotInfo.caseUsageExternalId,
          priceBookEntryId: lotInfo.priceBookEntryId,
          salesUnitOfMeasure: lotInfo.salesUnitOfMeasure,
          deliveredDate: lotInfo.deliveredDate,
        }),
      });
    }
  });

  return payload;
};
